export default __webpack_public_path__ + "static/media/anastasia_aivatoglou.f86d0344.png";